import { Component, computed, OnInit, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import {
    selectShipmentEditorViolations,
    selectShipmentEditorValidationMode
} from '../../../store/shipment-editor/shipment-editor.state';
import { Violation } from '../../../models/violation';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { IconComponent } from '../../shared/icon/icon.component';
import { MatList, MatListItem } from '@angular/material/list';
import { ValidationMode } from '../../../enum/validation-mode.enum';

@Component({
    selector: 'app-violations-modal',
    templateUrl: './violations-modal.component.html',
    styleUrls: ['./violations-modal.component.scss'],
    imports: [ MatList, MatListItem, IconComponent, MatButton ]
})
export class ViolationsModalComponent {

    constructor(private dialogRef: MatDialogRef<ViolationsModalComponent>,
                private store: Store<AppState>) {
    }

    public violations: Signal<Violation[]> = this.store.selectSignal(selectShipmentEditorViolations);
    public validationMode: Signal<ValidationMode> = this.store.selectSignal(selectShipmentEditorValidationMode);
    public quoteMode = computed(() => this.validationMode() === ValidationMode.QUOTE);
    public submitMode = computed(() => this.validationMode() === ValidationMode.SUBMIT);

    close(): void {
        this.dialogRef.close();
    }

}
